import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var hamburger = {
    selector: '.hamburger',
    init: function() {
        var self = this,
            $hamburger = $( self.selector ),
            $navigation = $( '.navigation' );

        var navigation = document.querySelector( '.navigation__container' );

        $hamburger.on( 'click', function( e ) {
            $navigation.addClass( 'navigation--animate' );
            $( document.body ).toggleClass( 'navigation-opened' );

            if ( $( document.body ).hasClass( 'navigation-opened' ) ) {
                disableBodyScroll( navigation, { reserveScrollBarGap: true } );
                var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
            } else {
                enableBodyScroll( navigation );
            }
        } );

        $( window ).on( 'resize', function( e ) {
            $navigation.removeClass( 'navigation--animate' );
            $( document.body ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );

        $navigation.find( 'a').on( 'click', function() {
            $( document.body ).removeClass( 'navigation-opened' );
            enableBodyScroll( navigation );
        } );
    }
}

export {
    hamburger
};
